/**
 * What an EMPLOYEE reads on the submission form beyond the option names themselves. Categories
 * are shown by their canonical Airtable names (David, Oct 1 2026 — "only the name of the
 * category"), so a category added in the proxy appears with no change here.
 */
import type { TicketQueue } from '../../types/peopleTickets';

/** Section titles (David, Oct 1 2026). No subtitles: the categories inside say the rest. */
export const QUEUE_TITLES: Record<TicketQueue, string> = {
  'Business Partnering': 'Contract & Employment',
  'Payroll & Benefits': 'Payroll, Benefits and Long-Term Absences',
  Workplace: 'Office',
};

/** The first question a category asks, when it has sub-options. */
export const SUBCATEGORY_LABEL: Record<string, string> = {
  Benefits: 'Which benefit?',
  Restock: 'What needs restocking?',
  Keycard: 'What happened?',
};

/**
 * Display labels for option VALUES that read too long on a button. The value sent stays the
 * Airtable option name; only the label changes.
 */
export const OPTION_LABELS: Record<string, string> = {
  'Out of stock in the office': 'Out of stock',
};

export function optionLabel(value: string): string {
  return OPTION_LABELS[value] ?? value;
}

/** The description's question, worded for what was picked. */
export function descriptionLabel(category: string): string {
  if (category === 'Keycard') return 'Anything else we should know? (optional)';
  if (category === 'Repair / Damage') return 'What is damaged?';
  if (category === 'Restock') return 'Which items, and how many?';
  return 'Describe your request';
}

/** What Urgent means, next to the question (David, Oct 1 2026). */
export const URGENCY_HINT =
  'Urgent = critically needs resolution within 1–2 days. Regular tickets are handled within about a week.';

/** When to expect a reply, by urgency — the same promise URGENCY_HINT makes on the form. */
export const RESPONSE_TIME: Record<string, string> = {
  Urgent: 'within 1–2 days',
  Regular: 'within about a week',
};
